<template>
  <div>
    <div class="row">
      <trip
          :key="`resume-trip-${Object.keys((model || {}).trip).length}`"
          v-model="(model || {}).trip"
          :purchase-orders="uniquePurchaseOrders"
          :total-box="model.box"
          class="d-print-none"
      />
      <unload
          :key="`resume-unload-${Object.keys((model || {}).trip).length}`"
          v-model="model"
          :purchase-orders="uniquePurchaseOrders"
          :active-tab="activeTab"
          class="d-print-none"
      />
      <sale-payment
          :key="`resume-sale-payment-${Object.keys(model).length}`"
          v-model="model"
          class="d-print-none"
      ></sale-payment>
      <balance
          :key="`resume-balance-${Object.keys((model || {}).sale_items).length}`"
          v-model="model"
          v-if="!isJalaHarvest"
          :active-tab="activeTab"
          class="d-print-none"
      ></balance>
      <img class="d-none d-print-block" src="@/assets/images/jala.svg" alt="JALA Logo" style="height: 25px;margin-bottom: 24px"/>
      <trip-export
          :key="`export-trip-${Object.keys((model || {}).trip).length}`"
          v-model="(model || {}).trip"
          :purchase-orders="uniquePurchaseOrders"
          :total-box="model.box"
          :class="{
            'd-none': true,
            'd-print-block': exportItems.includes('trip'),
            'd-print-none': !exportItems.includes('trip'),
            'mb-2': true,
          }"
      />
      <delivery-order-export
          :key="`export-delivery-order-${Object.keys(model).length}`"
          v-model="model"
          :class="{
            'd-none': true,
            'd-print-block': exportItems.includes('delivery_order'),
            'd-print-none': !exportItems.includes('delivery_order'),
            'mb-2': true,
          }"
      />
      <unload-export
          :key="`export-unload-${Object.keys((model || {}).trip).length}`"
          v-model="model"
          :active-tab="activeTab"
          :export-items="exportItems"
          :purchase-orders="uniquePurchaseOrders"
          :class="{
            'd-none': true,
            'd-print-block': exportItems.includes('unload'),
            'd-print-none': !exportItems.includes('unload'),
            'mb-2': true,
          }"
      />
      <sale-payment-export
          :key="`export-sale-payment-${Object.keys(model).length}`"
          v-model="model"
          :class="{
            'd-none': true,
            'd-print-block': exportItems.includes('sale_payment'),
            'd-print-none': !exportItems.includes('sale_payment'),
            'mb-2': true,
          }"
      ></sale-payment-export>
      <balance-export
          v-if="exportItems.includes('balance') && !exportItems.includes('unload')"
          :key="`export-balance-${Object.keys((model || {}).sale_items).length}`"
          v-model="model"
          :active-tab="activeTab"
          :class="{
            'd-none': true,
            'd-print-block': exportItems.includes('balance'),
            'd-print-none': !exportItems.includes('balance'),
            'mb-2': true,
          }"
      ></balance-export>
      <summary-card-export
          :key="`export-summary-${Object.keys(model).length}`"
          v-model="model"
          :active-tab="activeTab"
          class="d-none d-print-block"
      />
      <note-export
          :class="{
            'd-none': true,
            'd-print-block': exportItems.includes('note'),
            'd-print-none': !exportItems.includes('note')
          }"
          v-model="(model || {}).description"
      />
      <div class="text-center">
        <sign-export
            :export-attachment="exportItems.includes('unload') || exportItems.includes('balance')"
            :file-extension="((model || {}).files[0] || {}).extension"
            :file-url="((model || {}).files[0] || {}).url"
        />
      </div>
      <export-footer
          class="d-none d-print-block print-footer"
          style="color: #0084F3;"
      />
    </div>
  </div>
</template>

<script>
import Balance from './balance'
import BalanceExport from './balance-export'
import DeliveryOrderExport from './delivery-order-export'
import ExportFooter from './export-footer'
import NoteExport from '../note-export'
import SalePayment from './sale-payment'
import SalePaymentExport from './sale-payment-export'
import SignExport from './sign-export'
import SummaryCardExport from './factories/summary-card-export'
import Trip from './trip'
import TripExport from './trip-export'
import Unload from './unload'
import UnloadExport from './unload-export'

export default {
  name: 'factory',
  components: {
    Balance,
    BalanceExport,
    DeliveryOrderExport,
    ExportFooter,
    NoteExport,
    SalePayment,
    SalePaymentExport,
    SignExport,
    SummaryCardExport,
    Trip,
    TripExport,
    Unload,
    UnloadExport,
  },
  props: {
    activeTab: {type: String, default: 'admin'},
    exportItems: {type: Array, default() { return [] }},
    value: {type: Object, default: function () { return {} }},
  },
  data() {
    return {
      model: this.value,
    }
  },
  computed: {
    isJalaHarvest() {
      return this.model?.type === 'harvest'
    },
    trippedAt() {
      if (!this.model?.trip?.tripped_at) return '-'
      return this.$moment.utc(this.model.trip.tripped_at).local().format('DD MMMM YYYY')
    },
    uniquePurchaseOrders() {
      if (!this.value?.trip?.trip_items) return []
      let purchaseOrders = this.value.trip.trip_items.filter(({ purchase_item: {purchase_order} }) => purchase_order).map(({ purchase_item: {purchase_order} }) => purchase_order)

      return this.lodash.uniqBy(purchaseOrders, 'id')
    }
  },
}
</script>

<style lang="scss" scoped>
@media print {
  .print-footer {
    position: fixed;
    bottom: 0;
  }
}
</style>